import Calendar from "./fullcalendar";
import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { createTask, fetchAllTask } from "../../core/data/redux/calendar/calendarAction";
import { AppDispatch } from "../../core/data/redux/store";
import Enum from '../../core/common/Enum/enum';
import { Button } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import { decryptData } from "../../core/utils/encryptUtils";

function CustomCalendar() {

  const { user } = useSelector((state: any) => state.auth);
  const { calendar } = useSelector((state: any) => state.calendar);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const dispatch = useDispatch<AppDispatch>();


  const isMobile = window.innerWidth < 768;
  const sidebarWidth = 251;

  // Permission
  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];

  const canAdd = permissions.includes("Add") || permissions.includes("AllowAll");


  const openForm = () => setShowForm(true);

  const closeForm = () => setShowForm(false);


  const calendarContainerStyle: React.CSSProperties = {
    marginLeft: isMobile ? "0px" : `${sidebarWidth}px`,
    width: isMobile ? "100%" : `calc(100% - ${sidebarWidth}px)`,
    padding: isMobile ? "10px" : "20px",
    boxSizing: "border-box",
    transition: "all 0.3s ease-in-out",
  };

  return (
    <div
      className="container-fluid text-center mt-1 position-relative main-content"
      style={{ paddingTop: "80px", overflow: "auto" }}
    >


      <div className="d-flex justify-content-between align-items-center mb-4">
        {/* Left Section - Color legends */}
        <div style={calendarContainerStyle}>
          <div className="d-flex align-items-center gap-2">
            <span
              style={{
                width: "20px",
                height: "5px",
                backgroundColor: "#FFCDD2",
                display: "inline-block",
                borderRadius: "2px",
              }}
            ></span>
            <span>Holiday</span>



            <span
              style={{
                width: "20px",
                height: "5px",
                backgroundColor: "#FFE0B2",
                display: "inline-block",
                borderRadius: "2px",
              }}
            ></span>
            <span>Training</span>

            <span
              style={{
                width: "20px",
                height: "5px",
                backgroundColor: "#6A1B9A",
                display: "inline-block",
                borderRadius: "2px",
              }}
            ></span>
            <span>Birthday</span>

            <span
              style={{
                width: "20px",
                height: "5px",
                backgroundColor: "#BBDEFB",
                display: "inline-block",
                borderRadius: "2px",
              }}
            ></span>
            <span>Event</span>


          </div>

          <div className="d-flex align-items-center gap-2">

          </div>

          <div className="d-flex align-items-center gap-2">
          </div>
        </div>

        {/* Right Section - Add Task button */}
        {/* <div className="text-end d-flex my-xl-auto right-content align-items-center flex-wrap ">
  <button
   className="btn btn-primary d-flex align-items-center"
    style={{
      fontWeight: 500,
      fontSize: "14px",
      transition: "all 0.3s ease",
    }}
    onClick={() => setShowForm(true)}
  >
    <i className="fa fa-plus" aria-hidden="true"></i>
    Add Taskf
  </button>
</div> */}

        {canAdd && (
          <div className="mb-2">
            <Button
              type="primary"
              className="btn btn-primary d-flex align-items-center"
              onClick={() => setShowForm(true)}
            >
              <PlusCircleOutlined className="me-2" />
              Add Event
            </Button>
          </div>
        )}

      </div>






      {/* Calendar component */}
      <div style={calendarContainerStyle}>
        <Calendar showForms={showForm} setShowForms={setShowForm} />
      </div>


    </div>


  );
}

export default CustomCalendar;
